import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Stack } from "@mui/material";
import IconLoader from "@/features/Common/components/IconLoader";
import ScreenWrapper from "../../Common/ScreenWrapper";
import SleepCard from "./InfoCard";
import SleepChart, { SleepChartDataPoint } from "./SleepChart";
import HereToHelpCard from "../../HereToHelpCard";
import { WellnessScoreStatus } from "../../Common/types";

export interface SleepScreenProps {
  chartData: SleepChartDataPoint[];
  status: WellnessScoreStatus;
  lastUpdated?: string;
  onBack?: () => void;
  onOpenLifestyle?: () => void;
}

export default function SleepScreen({
  chartData,
  status,
  lastUpdated,
  onBack,
}: SleepScreenProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBack = onBack ?? (() => navigate(-1));

  const currentPoint =
    chartData.find((p) => p.isSelected) ?? chartData[chartData.length - 1];
  const hoursPerNight = currentPoint?.sleepHours ?? 0;

  return (
    <ScreenWrapper onBack={handleBack} title={t("Sleep.screenTitle")}>
      <Stack gap={2}>
        <SleepCard
          hoursPerNight={hoursPerNight}
          valueDisplayLabel={currentPoint?.valueDisplayLabel}
          lastUpdated={lastUpdated}
        />
        <SleepChart data={chartData} />
        <HereToHelpCard
          title={t("HereToHelpCard.title")}
          description={t("HereToHelpCard.description")}
          button={{
            text: t("HereToHelpCard.button.text"),
            icon: <IconLoader icon="SpeakToADoctorIcon" />,
          }}
        />
      </Stack>
    </ScreenWrapper>
  );
}
